import React, { useCallback, useState } from 'react';
import RestaurantListing from './Components/RestaurantsList';
import { useNavigate, useParams, useSearchParams } from 'react-router-dom';
import { getAreaRestaurants } from '../../lib/api/feed.apis';
import { slugify, useUserActivity } from './Explore/services';
import { Helmet } from 'react-helmet';

const AreaRests: React.FC = () => {
  const [searchParams] = useSearchParams();
  const { trackClick } = useUserActivity();
  const areaName = searchParams.get('name');
  
  const navigate = useNavigate();

    const handleCardClick = useCallback((id: string, name: string) => {
      trackClick(id.toString());
      navigate(`/restaurant/${id || "1"}/${slugify(name)}`);
    }, [trackClick, navigate]);

    const handleBack = () => {
      if (window.history.length > 1) {
      navigate(-1);
      } else {
      navigate("/");
      }
    };
    
    // Safety: handle missing area name
    if (!areaName) {
        return (
        <div>
            <p>Area not specified.</p>
            <button onClick={() => navigate("/")}>Home</button>
        </div>
        );
    }

  return (
    <>
      <Helmet>
        <title>Best Restaurants in {areaName} | Reserve Tables – Gemio</title>
        <meta
          name="description"
          content={`Discover and reserve the best restaurants in ${areaName} with Gemio. Browse menus, read reviews, and book a table at top dining spots in ${areaName}.`}
        />
      </Helmet>
      <RestaurantListing
        title={`Restaurants in ${areaName}`}
        fetchRestaurants={(page, filters) => getAreaRestaurants(areaName, filters, page)}
        onBack={handleBack}
        onRestaurantClick={handleCardClick}
      />
    </>
  );
};

export default AreaRests;
